import {forwardRef, HTMLAttributes} from 'react'
import {StyledGrid, StyledGridItem} from './style'
import {FlexboxProps} from '@/components/ui/flexbox/FlexBox'
import {CSSProperties} from 'styled-components'

export type GridProps = HTMLAttributes<HTMLDivElement> & {
    columns: number
    gap?: number
    columnGap?: number
    rowGap?: number
    fullWidth?: boolean
}

export const Grid = forwardRef<HTMLInputElement, GridProps>(
    ({columns, gap, columnGap, rowGap, fullWidth, ...props}: GridProps, ref) => (
        <StyledGrid
            ref={ref}
            $columns={columns}
            $gap={gap}
            $columnGap={columnGap}
            $rowGap={rowGap}
            $fullWidth={fullWidth}
            {...props}
        />
    )
)

export type GridItemProps = FlexboxProps<'div'> & {
    startColumn?: number
    endColumn?: number
    spanColumn?: number
    justify?: CSSProperties['justifyContent']
}

export const GridItem = ({startColumn, endColumn, spanColumn, justify, ...props}: GridItemProps) => (
    <StyledGridItem
        $startColumn={startColumn}
        $endColumn={endColumn}
        $spanColumn={spanColumn}
        $justify={justify}
        {...props}
    />
)
